import { DependencyList, useEffect, useRef, useState } from 'react';

let getScrollbarWidth = () => {
  const scrollContainer = document.createElement('div');
  scrollContainer.style.cssText =
    'position:absolute;left:0;top:0;visibility:hidden;overflow:scroll';
  document.body.appendChild(scrollContainer);
  const scrollbarWidth = scrollContainer.offsetWidth - scrollContainer.clientWidth;
  document.body.removeChild(scrollContainer);

  getScrollbarWidth = () => scrollbarWidth;

  return scrollbarWidth;
};

export const useScrollbarWidth = (deps: DependencyList = []) => {
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer && getScrollbarWidth() > 0) {
      setScrollbarWidth(scrollContainer.offsetWidth - scrollContainer.clientWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return [scrollbarWidth, scrollContainerRef] as const;
};
